import { getRandomGiftEnergyCreative } from 'src/creatives/gift';
import { getCreativeText } from 'src/creatives/text';
import { Feature } from 'src/replicant/analytics';
import { shareAsync, updateAsync } from 'src/lib/sharing';

/**
 * Send one gift over update async
 */
export async function sendGiftU2U(receiverID: string, subFeature: string) {
  await updateAsync({
    receiverID,
    template: 'dynamic_rect',
    confirmPopup: false,
    creativeAsset: await getRandomGiftEnergyCreative(),
    creativeText: getCreativeText('energy_gift'),
    data: {
      feature: Feature.GIFTS._,
      $subFeature: subFeature,
    },
  });
}

/**
 * Send mass gifts over share async API
 */
export async function sendMassGiftsShare(receiverIDs: string[]) {
  return shareAsync({
    receiverIDs,
    template: 'dynamic_rect',
    confirmPopup: false,
    creativeAsset: await getRandomGiftEnergyCreative(),
    creativeText: getCreativeText('energy_gift'),
    data: {
      feature: Feature.GIFTS._,
      $subFeature: Feature.GIFTS.SEND_ENERGY_ALL,
    },
  });
}
